<template>
  <div v-if="rewardPopUp" class="blur"></div>
  <div class="d-flex flex-column justify-content-center align-items-center col-12">
    <div class="d-flex justify-content-between align-items-center col-11 mt-4 ">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"
           class="col-5" alt="logo"/>
      <div class="d-flex flex-column justify-content-center align-items-end col-5">
        <div class="d-flex justify-content-center align-items-center  col-5 gap-1"
             style="border: 2px solid black; border-radius: 15px">
          <div class="col-4 mt-2 mb-2 fw-bold">{{ userStats?.TotalCoins }}</div>
          <img src="@/assets/gameplay/coins-medium.png" class="col-4 mt-2 mb-2" alt="coins"/>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <CarouselComponent :season="currentSeason"/>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <img :src="seasonalBanner" class="col-11" alt="seasonal banner"/>
    </div>
    <div v-if="showRandomButton()" @click="playNowClicked(false)"
         class="d-flex flex-column justify-content-center align-items-center col-12">
      <div class="col-11 text-center text-uppercase fw-bold p-3 mt-2 " style="border-radius: 30px;background: #FFCB05;">
        Play Random
      </div>
    </div>

    <div v-if="showRandomButton()" class="d-flex justify-content-center align-items-center col-12 gap-1 mt-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="2" viewBox="0 0 36 2" fill="none">
        <path d="M0.937256 1.12219H35.1214" stroke="black" stroke-opacity="0.8" stroke-width="0.727321"/>
      </svg>
      <div style="color: #000F56; text-align: center; font-weight: 700; font-size: 20px"> OR</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="2" viewBox="0 0 36 2" fill="none">
        <path d="M0.937256 1.12219H35.1214" stroke="black" stroke-opacity="0.8" stroke-width="0.727321"/>
      </svg>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-start col-11 mt-3 category-bg">
      <div class="mx-4 fw-bold m-3" style="font-size: 19px">
        Choose Category:
      </div>
      <div class="d-flex justify-content-around align-items-center col-12 mb-4">
        <div class="d-flex flex-column justify-content-center align-items-center col-5 position-relative">
          <img src="@/assets/home/music-trivia.png" @click="onCategoryClicked(44)" class="col-12"/>
          <img src="@/assets/home/locked-overlay.png" @click="showLimitModal = true" v-if="checkIfCategoryIsLocked(44)"
               class="col-12" style="position: absolute; top: 0"/>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center col-5 position-relative">
          <img src="@/assets/home/guess-song.png" @click="onCategoryClicked(46)" class="col-12"/>
          <img src="@/assets/home/locked-overlay.png" @click="showLimitModal = true" v-if="checkIfCategoryIsLocked(46)"
               class="col-12" style="position: absolute; top: 0"/>
        </div>
      </div>
    </div>

    <div v-if="this.getServiceIdMapNumber(user.serviceId) === 1" @click="subscribeMtnClicked()"
         class="d-flex flex-column justify-content-center align-items-center col-12 mt-4">
      <img src="@/assets/home/vip-pass.png" class="col-11"/>
    </div>
    <div v-if="showAvatarPopup" class="d-flex flex-column justify-content-center align-items-center col-12">
      <ChooseAvatar/>

    </div>

    <FreeTutorialComponent1
        v-if="isFreUser && showTutorial"
        :isLoggedIn="isUserLoggedIn"
        :hasUserPlayedBefore="hasUserPlayedBefore"
        @closeTutorial="handleClose"
    />

    <VipTutorialCompnent
        v-if="!isFreUser && showTutorial"
        :isLoggedIn="isUserLoggedIn"
        :hasUserPlayedBefore="hasUserPlayedBefore"
        @closeTutorial="handleClose"
    />

    <div v-if="showLimitModal" class="d-flex flex-column justify-content-center align-items-center col-12">
      <LimitReachedPopUp @close="showLimitModal = false"/>
    </div>
    <div v-if="rewardPopUp" class="reward-popup">
      <RewardPopup :userPins="userPinCodes"/>
    </div>
  </div>
</template>

<script>

import CarouselComponent from "@/views/components/CarouselComponent.vue";
import DepService from "@/api/services/depService";
import {mapMutations, mapState} from "vuex";
import ChooseAvatar from "@/views/components/ChooseAvatar.vue";
import TriviaService from "@/api/services/triviaService";
import {mtnServiceIdMap, serviceIdMap} from "@/config";
import FreeTutorialComponent1 from "@/views/components/FreeTutorialComponent1.vue";
import VipTutorialCompnent from "@/views/components/VipTutorialCompnent.vue";
import LimitReachedPopUp from "@/views/components/LimitReachedPopUp.vue";
import RewardCampaignService from "@/api/services/rewardsService";
import RewardPopup from "@/views/components/RewardPopUp.vue";

export default {
  name: 'HomeView',
  components: {
    RewardPopup,
    LimitReachedPopUp,
    VipTutorialCompnent,
    FreeTutorialComponent1,
    ChooseAvatar,
    CarouselComponent
  },
  data() {
    return {
      showAvatarPopup: false,
      showLimitModal: false,
      showTutorial: true,
      userPinCodes: []
    }
  },
  computed: {
    ...mapState(['user', 'productId', 'userStats', 'gameState', 'categoryGameState', 'isFreeUser', 'currentSeason', 'rewardPopUp']),

    seasonalBanner() {
      const banners = {
        'summer': require('@/assets/banners/Summer.webp'),
        'autumn': require('@/assets/banners/Autumn.webp'),
        'winter': require('@/assets/banners/Winter.webp'),
        'back2school': require('@/assets/banners/Back2School.webp'),
        'vday': require('@/assets/banners/V-Day.webp'),
        'easter': require('@/assets/banners/Easter.webp'),
        'christmas': require('@/assets/banners/Christmas.webp'),
      };

      return banners[this.currentSeason] || require('@/assets/banners/Summer.webp');
    },

    completedCategories() {
      if (!this.categoryGameState || !Array.isArray(this.categoryGameState)) return [];

      return this.categoryGameState
          .filter(category => category.CategoryComplete === 1)
          .map(category => category.QuestionCategoryId);
    },
    isFreUser() {
      return this.getServiceIdMapNumber(this.user.serviceId) === 1
    },
    isUserLoggedIn() {
      return !!this.user?.msisdn
    },
    hasUserPlayedBefore() {
      return this.gameState?.GameComplete || this.categoryGameState?.length > 0
    }

  },
  methods: {
    ...mapMutations(['setGameId', 'setUserQuestions', 'setQuestionCategoryId', 'setRandomizeQuestions', 'setQuestionNumber', 'setGameState', 'setCategoryGameState', 'setUserStats', 'setIsFreeUser', 'setRewardPopup']),
    async getUser() {
      const userResponse = (await DepService.getUserViaProductId(this.user.msisdn, this.productId)).data;

      if (userResponse.avatar === undefined) {
        this.showAvatarPopup === true
      }
    },
    handleClose() {
      this.showTutorial = false

      if (this.isFreUser) {
        localStorage.setItem('freeTutorialCompleted', 'true')
      } else {
        localStorage.setItem('vipTutorialCompleted', 'true')
      }
    },
    showRandomButton() {
      return this.getServiceIdMapNumber(this.user.serviceId) !== 1;
    },
    isRandomLocked() {
      if (this.gameState?.GameComplete) return true;
      if (this.gameState?.IsRandomize && this.gameState?.HasChosenBonusGame) return true;
      if (this.gameState?.SelectedCategory) return true;
      if (this.categoryGameState?.length > 0) return true;

      return false;
    },
    async onCategoryClicked(questionCategoryId) {
      if (this.checkIfCategoryIsLocked(questionCategoryId)) return;
      if (this.getServiceIdMapNumber(this.user.serviceId) === 1 && questionCategoryId > 44) return;
      if (this.gameState.GameComplete) return;

      this.setUserQuestionCategory(questionCategoryId);
      this.$router.push(`/game-play`);
    },
    async playNowClicked() {
      if (this.isRandomLocked()) {
        this.showLimitModal = true;

        return;
      }

      this.setUserQuestionCategory(null);
      this.$router.push(`/game-play`);
    },
    getServiceIdMapNumber(service) {
      return mtnServiceIdMap.get(service);
    },
    checkIfCategoryIsLocked(categoryId) {
      const isLocked = this.isCategoryLocked(categoryId);

      if (!isLocked && categoryId > 44) {
        if (this.getServiceIdMapNumber(this.user.serviceId) === 1) return true;
      }

      return isLocked;
    },
    async upsertGameState() {
      const recordsets = await this.getGameState();
      const firstRecordset = recordsets?.[0] ?? [];

      if (firstRecordset.length > 0) this.setGameState(firstRecordset[0]);
      if (firstRecordset.length < 1) {
        this.setGameState({GameComplete: false});
        this.setCategoryGameState([]);
      }
      if (recordsets?.length > 1) this.setCategoryGameState(recordsets[1])
    },
    async getGameState() {
      return await TriviaService.getGameState(this.user.msisdn, this.user.serviceId);
    },
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);

      this.setUserStats(recordsets?.[0]?.[0])
    },

    isCategoryLocked(categoryId) {
      if (this.gameState?.GameComplete) return true;
      if (this.gameState?.IsRandomize) return true;
      if (this.gameState?.SelectedCategory && this.gameState?.SelectedCategory !== categoryId) return true;

      if (this.categoryGameState?.length > 0) {
        let category = this.categoryGameState.find(item => item.QuestionCategoryId === categoryId);

        if (category) {
          return category.CategoryComplete === 1;
        }

        return false;
      }

      return false;
    },
    setUserQuestionCategory(questionCategoryId) {
      this.setQuestionCategoryId(questionCategoryId)
      this.setRandomizeQuestions(false)
    },
    async checkUserVoucherState() {
      if (!this.user) return

      const popupShownThisSession = sessionStorage.getItem('rewardPopupShown');

      if (popupShownThisSession) return;

      const response = await RewardCampaignService.getUserVouchers(this.user.msisdn, this.productId)

      if (response.userPins.length > 0) {
        this.userPinCodes = response.userPins
        this.setRewardPopup(true)
        sessionStorage.setItem('rewardPopupShown', 'true');
      }
    },
    subscribeMtnClicked() {
      this.$router.push('/upgrade-package')
    },
    checkFreeUser() {
      if (this.user && this.user.serviceId) {
        const serviceId = mtnServiceIdMap.get(this.user.serviceId);

        this.setIsFreeUser(serviceId === 1);
        console.log('Is Free User:', this.isFreeUser, 'Service ID:', serviceId);
      }
    }
  },
  async mounted() {
    const tutorialCompleted = localStorage.getItem('freeTutorialCompleted')
    const vipTutorial = localStorage.getItem('vipTutorialCompleted')

    if (this.isFreUser && tutorialCompleted) {
      this.showTutorial = false
    }
    if (!this.isFreUser && vipTutorial) {
      this.showTutorial = false
    }

    await this.getUser();
    await this.upsertGameState();
    await this.getUserStats();
    this.checkFreeUser();
    await this.checkUserVoucherState();
  },
  beforeMount() {
    console.log('beforeMount');
  }
}
</script>

<style>
.category-bg {
  border-radius: 12px;
  background: rgba(0, 15, 86, 0.10);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}

.reward-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
  width: 380px;
}

.blur {
  position: absolute;
  background: #00000096;
  backdrop-filter: blur(1px);
  top: 0;
  height: 100vh;
  width: 100vh;
  z-index: 1000;
}
</style>